import React from 'react';

interface InlineInfoProps {
  label: string;
  value: React.ReactNode;
  /** When set, the row is omitted entirely if the value is empty. */
  optional?: boolean;
}

/**
 * One row of the bordered label | value table (matches the branded alert PDF).
 *
 * Two columns (label | value) at every width — including phones — so the table
 * reads as a compact table instead of a heavy stack of full-width grey/white bars.
 * The label column shrinks on narrow screens and widens once there's room.
 */
const InlineInfo = ({ label, value, optional }: InlineInfoProps) => {
  if (
    (optional && !value) ||
    (typeof value === 'string' && value.length === 0)
  ) {
    return null;
  }

  return (
    <div className="xs:grid-cols-[minmax(10rem,1fr)_2fr] grid break-inside-avoid grid-cols-[minmax(6.5rem,38%)_1fr] items-stretch print:grid-cols-[minmax(10rem,1fr)_2fr]">
      <div className="body-xs text-gray bg-sand-300 border-sand-800 flex items-start border-r px-3.5 py-2">
        {label}
      </div>
      <div className="body-xs bg-white px-3.5 py-2 break-words whitespace-pre-line text-black">
        {value}
      </div>
    </div>
  );
};

export default InlineInfo;
